import React from 'react';
import DOMPurify from 'dompurify';
import './MessageBody.css';

/** Allowlist for message body HTML. Keeps secure-link spans (data-url) and semantic content. */
const SANITIZE_CONFIG = {
  ALLOWED_TAGS: ['p', 'div', 'span', 'br', 'strong', 'em', 'b', 'i', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'a', 'hr', 'small'],
  ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'style'],
  ADD_ATTR: ['data-url'],
};

/**
 * Renders message HTML inside a styled container with full semantic HTML support.
 * Sanitizes with DOMPurify before rendering. Callers should pass output of linkedText()
 * (or equivalent); sanitization here is defense-in-depth so secure-link spans remain safe.
 */
const MessageBody = ({ sanitizedHtml, className = '' }) => {
  const html = (sanitizedHtml != null && sanitizedHtml !== '') ? DOMPurify.sanitize(sanitizedHtml, SANITIZE_CONFIG) : '';
  return (
    <div
      dangerouslySetInnerHTML={{ __html: html }}
      className={`message_text${className ? ` ${className}` : ''}`}
    />
  );
};

export default MessageBody;
